import jsonLd from './functions/_jsonLd'
import search from './functions/search'
import searchInput from './functions/searchInput'

export default function JsonLdSearch ({ baseUrl, buy,
        category, locationObjectLd, offers }) {

    return <>
        { baseUrl &&
            jsonLd(searchInput(baseUrl)) }

        { offers?.length > 0 &&
            jsonLd(search(buy, category, offers)) }

        { locationObjectLd &&
            jsonLd(locationObjectLd) }
    </>
}